import { IconButton, Slider, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Dropzone from 'react-dropzone'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { IconComponents } from '../../assets/icons/icons';
import { getBaseApi } from '../../utils/app.utils';
import { MediaApi } from '../../api/media-file/MediaFile.api';
import clsx from 'clsx';
// import PreviewImage from '../preview-image/PreviewImage';
import CloseIcon from '@mui/icons-material/Close';
// import CropImage from '../crop-image/CropImage';

import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import { colors } from '../../constants/colors';
import { useTranslation } from 'react-i18next';

export type uploadImageProps = {
    view?: boolean;
    heading?: string;
    sub_heading?: string;
    image_file_blob: Blob | null;
    onChange: (file: File[]) => void;
    multi_file?: any[];
    onClear?: () => void;
    multiple?: boolean;
    image_file_url?: string;
    set_image_file_url?: React.Dispatch<React.SetStateAction<string>>;
    set_image_file_blob?: (blob_file: Blob) => void;
    disabled?: boolean;
    onClick?: () => void;
    dragInActiveText?: string;
    dragActiveText?: string;
    width?: React.CSSProperties['width'];
    height?: React.CSSProperties['height'];
    default_rotate?: number;
    maxFileSize?: number;
    not_allow_media?: boolean;
    required?: boolean;
    onDeleteMultiFileUpload?: (index: number) => void;
    hidden_clear_button?: boolean;
    no_border?: boolean;
    height_container?:string;
    enable_option_edit?: {
        src: string;
    }
}
export const linkPreviewImage = async (id_media_file: number): Promise<string> => {
    let path: string = ""
    const path_public: string = getBaseApi()
    await MediaApi.findOneFile(id_media_file).then((res) => {
        if (res.status < 300) {
            const data = res.data?.data || null
            path = `${path_public}/${data?.media_file_path}/${data?.media_file_name}`
        }
    })
    return path
}

export const UploadImagePreview: React.FC<uploadImageProps> = ({
    image_file_blob,
    sub_heading,
    onChange,
    onClear,
    multiple,
    heading,
    image_file_url,
    disabled, onClick,
    dragActiveText,
    width,
    height,
    no_border,
    maxFileSize,
    not_allow_media,
    multi_file,
    onDeleteMultiFileUpload,
    enable_option_edit,
    // set_image_file_url,
    // set_image_file_blob,
    default_rotate,
    required,
    hidden_clear_button,
    height_container = '500px',
    view

}: uploadImageProps) => {
    const { t } = useTranslation();
    const [loaded, setLoaded] = useState<boolean>(false);

    // const [path, set_path] = useState<string>("");
    const [slider, set_slider] = useState<number>(1);
    const [rotate, setRotate] = useState(default_rotate || 0);

    // useEffect(() => {
    //     const init = async () => {
    //         const response = await fetch("/resources/config.json");
    //         const results = await response.json();
    //         set_path(results?.REACT_APP_BASE_PUBLIC)
    //     }
    //     init();
    // }, [])

    useEffect(() => {
        if (default_rotate) {
            setRotate(default_rotate);
        }
    }, [default_rotate])

    return (
        <div className='w-full'>
            {heading && (
                <div className='w-full flex gap-4'>
                    <Typography fontSize={16} variant='h6'>
                        {heading} {" "} {required ? <span style={{ color: colors.red }}>*</span> : ""}
                    </Typography>
                    {sub_heading && (
                        <Typography style={{ color: "#828282", fontWeight: 100 }} className='font-thin'>
                            {sub_heading}
                        </Typography>
                    )}
                </div>
            )}
            <Dropzone
                maxFiles={multiple ? Infinity : 1}
                accept={{
                    'image/*': [],
                }}
                maxSize={maxFileSize}
                multiple={multiple}
                disabled={disabled || !!image_file_blob || !!image_file_url}
                onDrop={(acceptedFiles) => {
                    onChange(acceptedFiles)
                }}>
                {({ getRootProps, getInputProps, isDragActive }) => (
                    <section className='w-full relative overflow-hidden'>
                        {(image_file_blob || image_file_url) && !hidden_clear_button && (
                            <IconButton disabled={view} onClick={view ? undefined : onClear} sx={{
                                position: "absolute",
                                right: 10,
                                top: 10,
                                zIndex: 99
                            }}>
                                <HighlightOffIcon />
                            </IconButton>
                        )}
                        {(!image_file_blob && !image_file_url) && !isDragActive && onClick && (
                            <IconButton sx={{
                                position: "absolute",
                                right: 10,
                                top: 10
                            }} onClick={() => !not_allow_media && onClick?.()}>
                                <IconComponents.UploadImageIcon />
                            </IconButton>
                        )}
                        <div className={clsx(`w-full cursor-pointer flex justify-center items-center h-[${height_container}] overflow-hidden`, {
                            'h-full flex-wrap justify-center items-center': multiple,
                            'border-2': !no_border
                        })} {...getRootProps()}>
                            {(!image_file_blob && !image_file_url) && !isDragActive && (
                                <>
                                    {dragActiveText ? (
                                        <Typography variant='h6'>
                                            {dragActiveText}
                                        </Typography>
                                    ) : (
                                        <div className={clsx('flex flex-col justify-center items-center', {
                                            'py-10': multiple
                                        })}>
                                            <span onClick={() => !not_allow_media && onClick?.()} className='w-full flex justify-center items-center'>
                                                <IconComponents.ImageSelectIcon />
                                            </span>
                                            <span className='mt-4'>
                                                <Typography variant='h6'>
                                                    {t("เพิ่มไฟล์ภาพ")}
                                                </Typography>
                                            </span>
                                            <span className='font-extralight'>
                                                {t("สกุล png,jpg,jpeg ขนาดไม่เกิน 10MB")}
                                            </span>
                                        </div>
                                    )}
                                </>
                            )}
                            {(!image_file_blob && !image_file_url) && isDragActive && (
                                <Typography variant='h6' className='animate-bounce'>
                                    {dragActiveText ? t(dragActiveText) : t("วางไฟล์")}
                                </Typography>
                            )}

                            <input {...getInputProps()} />
                            {image_file_blob instanceof File && (
                                // <PreviewImage
                                //     image_url={URL.createObjectURL(image_file_blob)}
                                //     disable_show={false}
                                //     render_image={
                                //     }
                                //     />
                                <img onLoad={() => setLoaded(true)}
                                    className={`object-contain h-[${height || '200px'}]`}
                                    width={width || 500} height={height || 290}
                                    src={URL.createObjectURL(image_file_blob)} alt="image_file_blob"
                                />
                            )}
                            {multiple ? (
                                <>
                                    {multi_file && multi_file?.length > 0 && (
                                        <div
                                            style={{
                                                display: 'grid',
                                                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                                            }} className='w-full justify-center items-center gap-2 h-full'>
                                            {multi_file?.map((list, index) => {
                                                return (
                                                    <div onClick={(e) => {
                                                        e.stopPropagation();
                                                    }} className='w-full group relative h-full'>
                                                        <IconButton disabled={view} onClick={(e) => {
                                                            if (view) {
                                                                return false;
                                                            }
                                                            e.stopPropagation();
                                                            onDeleteMultiFileUpload && onDeleteMultiFileUpload?.(index)
                                                        }} sx={{ position: 'absolute', zIndex: 20 }} className='absolute top-0 right-0 z-20'>
                                                            <CloseIcon />
                                                        </IconButton>
                                                        <img
                                                            onLoad={() => setLoaded(true)}
                                                            loading='lazy'
                                                            className={`object-contain group-hover:opacity-45 transition-all duration-500 ${loaded ? 'blur-0 opacity-100' : 'blur-md opacity-30'}`}
                                                            width={width || "100%"}
                                                            height={500}
                                                            src={URL.createObjectURL(list)}
                                                            alt="image_file_url"
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    {image_file_url && (
                                        <>
                                            {enable_option_edit ? (
                                                // <CropImage
                                                //     src={image_file_url}
                                                //     width={width}
                                                //     height={height}
                                                //     rotate={rotate}
                                                //     slider={slider}
                                                //     disabled={disabled}
                                                //     onBlobChange={(blob_file) => {
                                                //         if (set_image_file_blob) {
                                                //             set_image_file_blob(blob_file);
                                                //         }
                                                //     }}
                                                //     set_image_url={(url) => {
                                                //         if (set_image_file_url && url) {
                                                //             set_image_file_url(url)
                                                //         }
                                                //     }}
                                                // />
                                                <></>
                                            ) : (
                                                <img
                                                    onLoad={() => setLoaded(true)}
                                                    loading='lazy'
                                                    className={`object-contain h-[${height || '200px'}] transition-all duration-500 ${loaded ? 'blur-0 opacity-100' : 'blur-md opacity-30'}`}
                                                    width={width || 500}
                                                    height={height || 290}
                                                    src={image_file_url} alt="image_file_url"
                                                />
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </section>
                )}
            </Dropzone>

            {enable_option_edit && (
                <div className='w-full h-full flex justify-center flex-col items-center min-h-[80px] bg-[#F6F6F6] mt-7 rounded-md border-2 border-[#DDE1EB]'>
                    <section>
                        <div className='flex justify-center items-center gap-2 w-full'>
                            <IconButton onClick={() => setRotate((prev) => prev - 90)}>
                                <RotateLeftIcon />
                            </IconButton>
                            <IconButton onClick={() => setRotate((prev) => prev + 90)}>
                                <RotateRightIcon />
                            </IconButton>
                        </div>
                    </section>
                    <section className='w-full flex justify-center items-center'>
                        <Slider
                            onChange={(e) => set_slider(+(e.target as HTMLInputElement).value)}
                            value={slider}
                            min={1}
                            max={10}
                            aria-label="Default"
                            sx={{ width: "70%" }}
                            valueLabelDisplay="auto"
                            color='info'
                        />
                    </section>
                </div>
            )}
        </div>
    )
}
